import React from "react";
import { Link } from "react-router-dom";
import HoverButton from "../../component/HoverButton";
import PageLayout from "../../component/PageLayout";
import ProductTallyPrimeTabs from "../../component/Product-TallyPrime";
import IconRightArrow from "../../component/SvgIcons/IconRightArrow";
import IconTallyPrimelogo from "../../component/SvgIcons/IconTallyPrimelogo";
import "./style.css";

export default function TallyPrimeusingAWS() {
  return (
    <div className="TallyPrimebg thirdtab">
      <PageLayout>
        <ProductTallyPrimeTabs />
        <section className="TabfourTallyPrime-tab newdesign pt50">
          <div className="container">
            <div className="pb50 text-center d-flex flex-column gap50">
              <div className="awsservice d-flex align-items-center justify-content-center  gap50">
                <IconTallyPrimelogo />
                <span>X</span>
                <img
                  src="../images/TallyPrimeusingAWS/aws.png"
                  alt="aws service"
                />
              </div>
              <Link className="management">
                Best Business Management Software, <span>Now on Cloud</span>
              </Link>
            </div>

            <div className="PrimeusingAWS mb100">
              <div className="titletwo">
                <h2>
                  Best solution to access your{" "}
                  <span>Tally, anytime, anywhere</span>
                </h2>
              </div>
              <div className="best-innerbox d-flex flex-column-reverse flex-md-row align-items-center">
                <div className="best-solution">
                  <p>
                    Tally powered by AWS helps you to securely access Tally and
                    your business data anytime, anywhere. It’s enabled by a
                    virtual machine dedicated to your business that is made
                    easily available via our strong network of partners. So, you
                    get greater flexibility to collaborate with multiple users
                    working on the same data, at the same time.
                  </p>
                  <ul className="pt50 pb50">
                    <li>Reliable</li> <li>Secure</li>
                    <li>Simple</li>
                    <li>Affordable</li>
                  </ul>

                  <div className="button justify-content-center justify-content-md-start d-flex gap50">
                    <HoverButton btnclassname="btn btn-dark" to="/contact">
                      <label>
                        {" "}
                        Contact Us Now <IconRightArrow />
                      </label>
                    </HoverButton>
                  </div>
                </div>
                <img
                  src="../images/TallyPrimeusingAWS/tp-powered-by-aws-banner.webp"
                  className="img-fluid fadeIn"
                  alt="Tally Prime"
                />
              </div>
            </div>

            <div className="titletwo thirdtabthere text-center">
              <h2>
                Why choose tally powered by <span>AWS?</span>
              </h2>
            </div>

            <div className="aws-serviceuse-first">
              <div className="aws-serviceuse-picture">
                <img
                  src="../images/TallyPrimeusingAWS/reliability.svg"
                  alt="Your growth Partner"
                />
              </div>
              <div className="aws-serviceuse-information">
                <h4>Securely access TallyPrime from anywhere, anytime</h4>
                <p>
                  TallyPrime powered by AWS is your gateway to seamlessly
                  accessing TallyPrime and your business data through web
                  browsers and a virtual client (installed on system). Enjoy the
                  freedom to complete your work from anywhere, any time that
                  suits you.
                </p>
              </div>
            </div>

            <div className="aws-serviceuse-second">
              <div className="aws-serviceuse-picture">
                <img
                  src="../images/TallyPrimeusingAWS/everything.svg"
                  alt="Your growth Partner"
                />
              </div>
              <div className="aws-serviceuse-information">
                <h4>Integrated productivity tools</h4>
                <p>
                  Why step out when everything you need is within your virtual
                  reach? TallyPrime powered by AWS comes fully equipped with a
                  suite of powerful tools, ensuring that you never have to leave
                  the virtual computer environment. Seamlessly view, edit, and
                  save documents in various formats using LibreOffice.
                </p>
                <p>
                  But that's not all—our platform goes the extra mile by
                  providing a curated selection of accessories designed to
                  enhance your day-to-day activities. Elevate your productivity,
                  simplify your tasks, and experience a world of efficiency
                  right at your fingertips with TallyPrime powered by AWS.
                </p>
              </div>
            </div>

            <div className="aws-serviceuse-thierd">
              <div className="aws-serviceuse-picture">
                <img
                  src="../images/TallyPrimeusingAWS/economical.svg"
                  alt="Your growth Partner"
                />
              </div>
              <div className="aws-serviceuse-information">
                <h4>Upgrade to new releases effortlessly</h4>
                <p>
                  Unlock a world of continuous improvement with TallyPrime
                  powered by AWS as you enjoy access to the latest product
                  upgrades and earlier releases. Transitioning between releases
                  has never been simpler, requiring no additional support.
                  Tailor your experience by choosing the release that perfectly
                  aligns with your unique business requirements. With TallyPrime
                  powered by AWS, we ensure a dynamic and customized journey for
                  each customer, empowering you to stay at the forefront of
                  innovation effortlessly.
                </p>
              </div>
            </div>

            <div className="aws-serviceuse-fourth">
              <div className="aws-serviceuse-picture">
                <img
                  src="../images/TallyPrimeusingAWS/flexibility.svg"
                  alt="Your growth Partner"
                />
              </div>
              <div className="aws-serviceuse-information">
                <h4>
                  Amplify your capabilities by integrating other applications
                </h4>
                <p>
                  Unlock the potential of your TallyPrime experience by
                  seamlessly integrating third-party applications. With the
                  enhanced capabilities of TallyPrime powered by AWS, you can
                  effortlessly exchange data to perform specific business
                  operations. Manage the integration process efficiently by
                  determining which users have the authority to sync, giving you
                  the flexibility and control. Elevate your business processes
                  with the expanded integration possibilities in TallyPrime,
                  providing you with the flexibility and efficiency you need for
                  success.
                </p>
              </div>
            </div>

            <div className="aws-serviceuse-fiveth">
              <div className="aws-serviceuse-picture">
                <img
                  src="../images/TallyPrimeusingAWS/platform-agnostic.svg"
                  alt="Your growth Partner"
                />
              </div>
              <div className="aws-serviceuse-information">
                <h4>Afford and scale seamlessly</h4>
                <p>
                  Affordability and scaling have never been easier – choose from
                  our diverse range of plans tailored to suit your evolving
                  needs. Plans starts as low as 600 INR per user, per month.
                </p>
                <p>
                  With TallyPrime powered by AWS, your business growth is not
                  just a milestone; it's a continuous journey of success with
                  scalable solutions right at your fingertips.
                </p>
              </div>
            </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
